import { Component, ElementRef, Input, ViewChild, computed, signal } from '@angular/core';

@Component({
  selector: 'cert-validation-summary',
  templateUrl: './validation-summary.component.html',
  standalone: false,
})
export class ValidationSummaryComponent {
  private static nextId = 0;
  readonly listId = `validation-summary-errors-${ValidationSummaryComponent.nextId++}`;
  readonly collapsedLimit = 15;
  readonly messages = signal<readonly string[]>([]);
  readonly expanded = signal(false);
  readonly visibleErrors = computed(() =>
    this.expanded() ? this.messages() : this.messages().slice(0, this.collapsedLimit),
  );
  @Input() heading = 'Unable to complete this action';
  @Input() set errors(value: readonly string[]) {
    this.messages.set(value);
    this.expanded.set(false);
  }
  @ViewChild('summary') private summary?: ElementRef<HTMLElement>;

  focus(): void {
    this.summary?.nativeElement.focus();
  }
}
